export const NONBFI_DETAIL_MODAL = 'NONBFI_DETAIL_MODAL';
export const BFI_DETAIL_MODAL = 'BFI_DETAIL_MODAL';
export const AUDIT_HISTORY_MODAL = 'AUDIT_HISTORY_MODAL';

export const setNonBfiDetailModal = (state) => (dispatch) => {
    dispatch({ type: NONBFI_DETAIL_MODAL, state });
};

export const setBfiDetailModal = (state) => (dispatch) => {
    dispatch({ type: BFI_DETAIL_MODAL, state });
};

export const setAuditHistoryModal = (state) => (dispatch) => {
    dispatch({ type: AUDIT_HISTORY_MODAL, state });
};

export default {
    NONBFI_DETAIL_MODAL,
    BFI_DETAIL_MODAL,
    AUDIT_HISTORY_MODAL,
    setNonBfiDetailModal,
    setBfiDetailModal,
    setAuditHistoryModal,
};
